export const MODAL_FADE_IN_TIMEOUT = 250;
export const MODAL_AUTO_CLOSE_TIMEOUT = 3000;
export const INPUT_TIMEOUT = 1000;
//regExp
export const emailReg = /^(([^а-яА-ЯЁё<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const TEL_VALUE_MIN_LENGH = 11;

export const TEST_OFFSET_SCROLL = 22;

/**
 * Сколько показывать кнопок страниц в постраничной навигации до и после актуальной
 * Пример:
 * SPRED_PAGES = 2
 * Всего 9 страниц навигации и сейчас просматривают 5ю
 * 1 ... 3 4 5 6 7 ... 9
 * */
export const SPRED_PAGES = 2;

//chart
export const CHART_LINE_COLOR = "#52B047";
